import angular from 'angular';
import { MeurhBeneficiosProrrogacaoFormController } from './prorrogacao.form.controller';

export class MeurhBeneficiosProrrogacaoFormComponent implements angular.IComponentOptions {
    static selector = 'meurhBeneficiosProrrogacaoFormComponent';
    static controller = MeurhBeneficiosProrrogacaoFormController;
    static template = require('!!html-loader!./prorrogacao.form.html');
    static transclude = true;
    static bindings = {
        tipoBeneficio: '<',
        limitDate: '<?',
        entity: '=',
        form: '<?',
        editable: '<'
    };
}
